import { useLayoutEffect, useRef } from "react";

// Fit the actual rendered text inside a fixed region without clipping or moving it.
export const useFittedText = (text, maxFontSize, enabled = true) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const element = textRef.current;
    if (!enabled || !container || !element) return;
    let active = true;

    const fit = () => {
      if (!active) return;
      const style = getComputedStyle(container);
      const height = container.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      const width = container.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      if (height <= 0 || width <= 0) return;
      const fits = (size) => {
        element.style.fontSize = `${size}px`;
        return element.scrollHeight <= height && element.scrollWidth <= width;
      };
      let low = 1;
      let high = maxFontSize;
      if (fits(high)) return;
      while (high - low > 0.5) {
        const mid = (low + high) / 2;
        if (fits(mid)) low = mid;
        else high = mid;
      }
      element.style.fontSize = `${low}px`;
    };

    fit();
    const observer = new ResizeObserver(fit);
    observer.observe(container);
    document.fonts?.ready.then(fit);
    return () => {
      active = false;
      observer.disconnect();
    };
  }, [text, maxFontSize, enabled]);

  return { containerRef, textRef };
};